import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useDispatch } from 'react-redux';
import { oidcActions } from './redux';
import { useAuthenticated } from './useAuthenticated';
import useLogin from './useLogin';

/** @deprecated just until we get sagas retired */
export const oidcContext = {};

/** @deprecated just until we get sagas retired */
export const oidcLoginRef = {
	current: (() => Promise.reject()) as ReturnType<typeof useLogin>,
};

export function ReduxConnector() {
	const dispatch = useDispatch();
	const context = useAuth();
	const { user, isLoading } = context;
	const isAuthenticated = useAuthenticated();

	// Expose functions directly to sagas
	Object.assign(oidcContext, context);
	oidcLoginRef.current = useLogin();

	// Copy user to redux
	useEffect(() => {
		dispatch(oidcActions.setUser(user));
	}, [dispatch, user]);

	// Copy user state to redux
	useEffect(() => {
		dispatch(oidcActions.setAuthenticated(isAuthenticated));
	}, [dispatch, isAuthenticated]);

	// Copy loading status to redux
	useEffect(() => {
		dispatch(oidcActions.setLoading(isLoading));
	}, [dispatch, isLoading]);

	// Emulate old oidc actions
	useEffect(() => {
		if (isLoading || isAuthenticated) return;
		dispatch({
			type: oidcActions.USER_EXPIRED,
		});
	}, [isLoading, dispatch, isAuthenticated]);

	return null;
}

export default ReduxConnector;
